'use strict';



export default class Calculator {
	constructor() {
		if($('.cost-table-holder').length > 0){

			if (innerWidth >= 1024){ 
				
				// DESKTOP ONLY*/
				$('a[data-action="find-cost"]').on("click", function(){
					calculate();
				});
				

				$('#go-back').on("click", function(){
					$('.options').removeClass('calculator-on');
					$('.bg.slide-1').addClass('active');
					$('.cost-table-holder').removeClass('active');
				});	
				
			} else if (innerWidth <= 1024) { 
				
				$('#show-cal').on("click", function(){
					$('.hero-txt.slide-1_1').addClass('active');
					$('.hero-txt.slide-1').removeClass('active');
				});
				
				$('a[data-action="find-cost"]').on("click", function(){
					calculate();
				});
				
				$('#go-back').on("click", function(){
					$('.options').removeClass('calculator-on');
					$('.bg.slide-1').addClass('active');
					$('.cost-table-holder,.hero-txt.slide-1_1').removeClass('active');
					$('.hero-txt.slide-1').addClass('active');
					
				});	
			}
			
			
			function calculate(){ 
				//Clear the UI
				$('.calulatorAmount').hide();
				$('ul.cost-table .amount').remove();//remove old amount 
				$('ul.cost-table .PayButtonForm').hide(); //remove pay button
				$('ul.cost-table input[name="Identifier"]').val(''); //remove pay button
				$('ul.cost-table li').removeClass('current'); // remove stling of current fine status box

				$('ul.cost-table .WarrantText').hide();
				$('ul.cost-table .warrantPendingText').show();

				$('#CalculatorError').html("");


				//Show the spinner
				$('ul.cost-table .cssload-container').show();

				var obligationNumber = $('#ObligationNumber').val();

				var target = $('a[data-action="find-cost"]').data('target');
				$.ajax({
					  method: "POST",
					  url: target,
					  data: { ObligationNumber: obligationNumber},
					  success:function( Result ){
						  	$('.cost-table-holder').addClass('active');

						  	$('.options').addClass('calculator-on');
							$('.bg.slide-1').removeClass('active');
							$('ul.cost-table .amount').remove();

					  		//show calculion amounts
							$('.calulatorAmount').show();

							//hide spinner
							$('ul.cost-table .cssload-container').hide();

							//Populate Cost values
							var overdueFee = Result.OverdueFee > 0 ? Result.OverdueFee : Result.DefaultReminder;
							var courtCost = Result.CourtCost > 0 ? Result.CourtCost : Result.DefaultEnforcement;
							var warrantFee = Result.WarrantFee > 0 ? Result.WarrantFee : Result.DefaultWarrant;
							addValuesToCaluclatorBox('Infringement', Result.TicketFee, null, 'Infringement penalty');
							addValuesToCaluclatorBox('PenaltyReminder', Result.TicketFee, overdueFee, 'Penalty Reminder Notice fee');
							addValuesToCaluclatorBox('NoticeOfFinalDemand', Result.TicketFee + overdueFee, courtCost, 'Collection fee');
							addValuesToCaluclatorBox('EnforcementWarrant', Result.TicketFee + overdueFee + courtCost, warrantFee, 'Enforcement Warrant fee');

							//If fine is in the warrant state change the text on the warrant pending box to say warrant
							if(Result.InfingementStatus == 3)
							{
								Result.InfingementSatusString = "NoticeOfFinalDemand";
							}
							else if(Result.InfingementStatus == 4 || Result.InfingementStatus == 5)
							{
								Result.InfingementSatusString = "EnforcementWarrant";
							}

							//Style current infringment charge and pay button
						  
						  	$('ul.cost-table li.previous').removeClass('previous');
							var CurrentFormStateBlock = $('ul.cost-table li[data-fine-status="'+Result.InfingementSatusString+'"]');
						  	var PreviousFormStateBlock = CurrentFormStateBlock.prev();
							CurrentFormStateBlock.addClass('current');
							PreviousFormStateBlock.addClass('previous');
                            CurrentFormStateBlock.find('.PayButtonForm').before('<p class="amount">$'+ parseFloat(Result.AmountDue).toFixed(2) +'</p>');
                            CurrentFormStateBlock.find('.PayButtonForm').show();
                            CurrentFormStateBlock.find('.PayButtonForm input[name="Identifier"]').val(obligationNumber);

					  },
					  error: function(xhr, ajaxOptions, thrownError) {

							var json = {};
							try
							{
								json = $.parseJSON(xhr.responseText);
							}
							catch(err){
								//was not passed back valid Json, we will just display a generic error message in this case.
							}

							$('#CalculatorError').html(json.Error.replace(/\\n/mg,"<br><br>") || "Something went wrong while processing the request.");

							$('ul.cost-table .cssload-container').hide();
							$('.calulatorAmount').hide();

					}
				});
			}

			function addValuesToCaluclatorBox(stage, amount, fee, subText)
			{
				var html = "";
				if (stage === "Infringement") {
					html = '<p class="cost totaldue cost-' + stage + '">$' + parseFloat(amount).toFixed(2) + '</p><p class="sub-txt"> ' + subText + '</p>';
				} else {
					html = '<p class="cost cost-' + stage + '">$' + parseFloat(amount).toFixed(2) + '</p><span class="plus">+</span><div class="fee"><p class="sub-txt"><span class="feeamount">*$'+parseFloat(fee).toFixed(2)+'</span> ' + subText + '</p></div><hr><p class="cost totaldue">$'+parseFloat(amount+fee).toFixed(2)+'</p>';
				}

				$('ul.cost-table li[data-fine-status="'+stage+'"] .calulatorAmount').html(html);
			}
		}
	}
}